var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "userDetails" },
    [
      _c(
        "el-drawer",
        {
          attrs: {
            direction: _vm.direction,
            title: _vm.initData.type !== "edit" ? "个人档案" : "",
            visible: _vm.drawerIsShow,
            size: "65%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.drawerIsShow = $event
            },
            close: _vm.handleClose,
          },
        },
        [
          _vm.initData.type === "add"
            ? _vm._t(
                "default",
                [
                  _c("div", { staticClass: "tabsEdit" }, [
                    _c("div", { staticClass: "tabs" }, [_vm._v("员工档案")]),
                  ]),
                ],
                { slot: "title" }
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.initData.type === "add"
            ? _c("div", { staticClass: "drawer-body" }, [
                _c(
                  "div",
                  { staticClass: "left" },
                  [
                    _c("LeftNavigation", {
                      attrs: {
                        componentStatus: _vm.initData,
                        imageUrl: _vm.photo,
                        tabtypes: _vm.tabtypes,
                      },
                      on: {
                        getImageUrl: _vm.getImageUrl,
                        pageJump: _vm.pageJump,
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { ref: "top", staticClass: "right" },
                  [
                    _c("formItemDataList", {
                      ref: "addData",
                      attrs: {
                        componentStatus: _vm.initData,
                        photo: _vm.photo,
                        tabtypes: _vm.tabtypes,
                      },
                      on: { submitOk: _vm.submitOk },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "button from-foot-btn fix btn-shadow" },
                  [
                    _c(
                      "el-button",
                      { attrs: { size: "small" }, on: { click: _vm.cancel } },
                      [_vm._v("取消")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { size: "small", type: "primary" },
                        on: { click: _vm.protect },
                      },
                      [_vm._v("保存")]
                    ),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.initData.type === "edit"
            ? _vm._t(
                "default",
                [
                  _c("div", { staticClass: "tabsEdit" }, [
                    _c(
                      "div",
                      { staticClass: "tabs" },
                      [
                        _c(
                          "el-tabs",
                          {
                            staticClass: "cr-header-tabs",
                            on: { "tab-click": _vm.handleClick },
                            model: {
                              value: _vm.tabsName,
                              callback: function ($$v) {
                                _vm.tabsName = $$v
                              },
                              expression: "tabsName",
                            },
                          },
                          [
                            _c("el-tab-pane", {
                              attrs: {
                                label: "个人档案",
                                name: "personalFile",
                              },
                            }),
                            _vm._v(" "),
                            _c("el-tab-pane", {
                              attrs: {
                                label: "个人经历",
                                name: "personalExperience",
                              },
                            }),
                            _vm._v(" "),
                            _vm.tabtypes !== 0
                              ? _c("el-tab-pane", {
                                  attrs: {
                                    label: "人事异动",
                                    name: "personnelChange",
                                  },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.tabtypes !== 0
                              ? _c("el-tab-pane", {
                                  attrs: {
                                    label: "调薪记录",
                                    name: "salaryAdjustmentRecord",
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.tabtypes == 1 && _vm.userInfo.uid !== ""
                      ? _c(
                          "div",
                          {
                            staticClass: "invitationUrl",
                            on: { click: _vm.perfectFn },
                          },
                          [
                            _c("el-link", { attrs: { underline: false } }, [
                              _c("i", {
                                staticClass: "iconfont icongerenjianli-yaoqing",
                              }),
                              _vm._v(" 邀请完善档案"),
                            ]),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]),
                ],
                { slot: "title" }
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.initData.type === "edit"
            ? _c(
                "div",
                { staticClass: "drawer-body" },
                [
                  _vm.tabsName === "personalFile"
                    ? [
                        _c(
                          "div",
                          { staticClass: "left" },
                          [
                            _c("LeftNavigation", {
                              attrs: {
                                componentStatus: _vm.initData,
                                imageUrl: _vm.photo,
                                tabtypes: _vm.tabtypes,
                                userInfo: _vm.userInfo,
                              },
                              on: {
                                getImageUrl: _vm.getImageUrl,
                                pageJump: _vm.pageJump,
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "right" },
                          [
                            _c("formItemDataList", {
                              ref: "editData",
                              attrs: {
                                id: _vm.id,
                                componentStatus: _vm.initData,
                                photo: _vm.photo,
                                tabtypes: _vm.tabtypes,
                              },
                              on: {
                                getPhoto: _vm.getPhoto,
                                userInfoFn: _vm.userInfoFn,
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.actionType
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "button from-foot-btn fix btn-shadow",
                              },
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { size: "small" },
                                    on: { click: _vm.cancel },
                                  },
                                  [_vm._v("取消")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      loading: _vm.isLoading,
                                      size: "small",
                                      type: "primary",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.inDuction(_vm.actionType)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.actionType == "入职"
                                          ? "入职"
                                          : "重新入职"
                                      )
                                    ),
                                  ]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.tabsName === "personalExperience"
                    ? [
                        _c(
                          "div",
                          { staticClass: "personalExperience" },
                          [
                            _c("formItemDataList", {
                              ref: "editWork",
                              attrs: {
                                id: _vm.id,
                                componentStatus: Object.assign(
                                  {},
                                  _vm.initData,
                                  { personalExperience: true }
                                ),
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.tabsName === "personnelChange"
                    ? [
                        _c("personnelChange", {
                          attrs: {
                            list: _vm.changeList,
                            tabsName: _vm.tabsName,
                          },
                        }),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.tabsName === "salaryAdjustmentRecord"
                    ? [
                        _c(
                          "div",
                          { staticStyle: { padding: "20px", width: "100%" } },
                          [
                            _vm.list && _vm.list.lenght !== 0
                              ? _c("personnelChange", {
                                  attrs: {
                                    list: _vm.list,
                                    tabsName: _vm.tabsName,
                                  },
                                  on: {
                                    deleteSalaryList: _vm.deleteSalaryList,
                                    getSalaryContent: _vm.getSalaryContent,
                                  },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _c("salaryAdjustmentRecord", {
                              ref: "salaryAdjustmentRecord",
                              attrs: { id: _vm.id },
                              on: { getSalaryList: _vm.getSalaryList },
                            }),
                          ],
                          1
                        ),
                      ]
                    : _vm._e(),
                ],
                2
              )
            : _vm._e(),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }